<section class="bg-white p-3 p-lg-4">
   <div class="">
      <header class="d-flex align-items-center justify-content-between gap-3 section-header">
         <h2 class="mb-0 ">Press Release</h2>
      </header>
      
      <div class="loader-grid" *ngIf="newsLoader">
         <div class="loader-item"  *ngFor="let i of [1,2,3,4,5,6]">
            <div class="skeleton-loader rounded-3 image-loader"></div>
            <div class="d-grid gap-2">
               <span class="skeleton-loader rounded-3 d-block headline-loader"></span>
               <span class="skeleton-loader rounded-3 d-block summary-loader"></span>
               <span class="skeleton-loader rounded-3 d-block summary-loader"></span>
            </div>
         </div>
      </div>
      
      <ng-container *ngIf="!newsLoader && news?.length > 0">
         <div class="news-grid-container">
            <a class="d-block text-decoration-none" *ngFor="let news of getFilteredNews(); trackBy: trackByNewsId" target="_blank" [href]="news.url">
               <article class="d-flex align-items-start gap-2 gap-lg-3 news-card">
                  <div class="bg-light flex-shrink-0 w-100 overflow-hidden news-image-wrapper">
                     <img class="img-fluid news-image" [appLazyLoadImage]="news.Image" placeholder="/assets/images/dashboard/news-lowres.png" [src]="news.Image" [alt]="news.Headline" *ngIf="news.Image; else noImage">
                     <ng-template #noImage>
                        <img class="img-fluid news-image" appLazyLoadImage="/assets/images/dashboard/stock-news.jpg" placeholder="/assets/images/dashboard/news-lowres.png" [alt]="news.Headline">
                     </ng-template>
                  </div>
                  <div class="flex-grow-1">
                     <h6 class="mb-2 news-headline line-clamp-2">
                        {{ news.headline }}
                     </h6>
                     <p class="mb-0 news-date">
                        {{ news.datetime | date : "dd MMM YYYY, HH:mm a" }}
                     </p>
                  </div>
               </article>
            </a>
         </div>

         <a class="btn d-flex align-items-center justify-content-center mx-auto mt-2 gap-2 text-nowrap p-0 view-all-btn" *ngIf="news?.length > 6" (click)="showNews = !showNews">
            <span>{{ showNews ? 'View Less' : 'View More'  }}</span>
            <!-- <i class="bi bi-arrow-right arrow-icon"></i> -->
         </a>
         
      </ng-container>

      <ng-container *ngIf="!newsLoader && news?.length === 0">
         <p class="no-data-text mb-0 text-center p-5 px-3">No press releases available for this stock</p>
      </ng-container>

   </div>
</section>




<!-- <div class="stock__main main__box">
   <div class="stock__information">
      <div class="news__header" [ngClass]="headerVisibility">
         <h2 class="news-title">Press release</h2>
         <div class="table__show-more" *ngIf="news?.length > 5" (click)="showNews = !showNews">
            <span>{{ showNews ? 'View Less' : 'View All' }}</span>
         </div>
      </div>
      <p class="mb-0 para-heading">Company released news and information</p>
      <div *ngIf="newsLoader">
         <div class="px-3" *ngFor="let n of [1,2,3,4,5,6]">
            <ngx-skeleton-loader count="1" appearance="line" animation="progress" [theme]="{ height: '80px', width: '100%', margin: '0px'}"></ngx-skeleton-loader>
         </div>
      </div>
      <div *ngIf="!newsLoader && news?.length">
        <div class="stock" *ngFor="let item of news | reletedNewsChange : showNews">
            <div class="stocks__news-image">
               <div
                  class="stock_image"
                  [ngStyle]="{ 'background-image': 'url(' + item.Image + ')' }"
                  *ngIf="item.Image"
               ></div>
               <div class="d-flex align-items-center justify-content-center no-stock_image" *ngIf="!item.Image">
                  <span class="fw-bold fs-4">{{ item.headline?.charAt(0) }}</span>
               </div>
            </div>
            <div class="stocks__news-links">
               <div class="content">
                  <h2 class="stock__title">
                     {{ item.datetime | date : "dd MMM YYYY, HH:mm a" }}
                  </h2>
                  <div class="stock_body stock__body-pc">
                     <a href="{{ item.url }}" target="_blank">{{
                        item.headline
                     }}</a>
                  </div>
                  <div class="stock_body stock__body-mobile">
                     <a href="{{ item.url }}" target="_blank">{{
                        item.headline
                     }}</a>
                  </div>
               </div>
            </div>
         </div>
         <div class="table__show-more p-3 d-lg-none" *ngIf="news?.length > 5" (click)="showNews = !showNews">
            <span>{{ showNews ? 'View Less' : 'View All' }}</span>
         </div>
      </div>
      <div *ngIf="!newsLoader && !news?.length">
        <p class="mb-0 text-center py-3">No news available for this stock</p>
      </div>
   </div>
</div> -->
